import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Auth from '../Components/auth';
import Web3 from 'web3';
import { ToastContainer, toast } from 'react-toastify';

function Web3wallet() {
    const [bnbBalance, setBnbBalance] = useState(0);
    const [rainoBalance, setRainoBalance] = useState(0);
    const [mbitBalance, setMbitBalance] = useState(0);
    const [usdtBalance, setUsdtBalance] = useState(0);
    const [account, setAccount] = useState(localStorage.getItem('web3_addess') || '');
    const [isCopied, setIsCopied] = useState(false);

    const web3 = new Web3("https://bsc-dataseed.binance.org/");

    // Token addresses
    const rainoTokenAddress = '0x339A5946b305bDD7FA7c54309cef53779b119457';
    const mbitTokenAddress = '0xC4d1f775857D6D68741B4BFef03c5A11F5953ecA';
    const usdtTokenAddress = '0x55d398326f99059ff775485246999027b3197955';

    // Minimal ABI required for balanceOf and decimals
    const erc20Abi = [
        {
            constant: true,
            inputs: [{ name: "account", type: "address" }],
            name: "balanceOf",
            outputs: [{ name: "", type: "uint256" }],
            type: "function"
        },
        {
            constant: true,
            inputs: [],
            name: "decimals",
            outputs: [{ name: "", type: "uint8" }],
            type: "function"
        }
    ];

    // Connect wallet on load if not already connected
    useEffect(() => {
        const connectWallet = async () => {
            if (!account && window.ethereum) {
                try {
                    const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
                    localStorage.setItem('web3_addess', accounts[0]);
                    setAccount(accounts[0]);
                } catch (err) {
                    console.error("Wallet connection rejected", err);
                }
            }
        };
        connectWallet();
    }, []);

    useEffect(() => {
        if (!account) return;

        const getBnbBalance = async () => {
            try {
                const balance = await web3.eth.getBalance(account);
                setBnbBalance(web3.utils.fromWei(balance, 'ether'));
            } catch (error) {
                console.error("Error getting BNB balance", error);
            }
        };

        const getTokenBalance = async (tokenAddress, setter) => {
            try {
                const contract = new web3.eth.Contract(erc20Abi, tokenAddress);
                const balance = await contract.methods.balanceOf(account).call();
                const decimals = await contract.methods.decimals().call();
                setter(balance / Math.pow(10, decimals));
            } catch (error) {
                console.error(`Error fetching token balance for ${tokenAddress}:`, error);
            }
        };

        getBnbBalance();
        getTokenBalance(rainoTokenAddress, setRainoBalance);
        getTokenBalance(mbitTokenAddress, setMbitBalance);
        getTokenBalance(usdtTokenAddress, setUsdtBalance);

    }, [account]);

    const copyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(account);
            setIsCopied(true);
            toast.success("Wallet address copied!", {
                position: toast.POSITION.TOP_RIGHT,
            });
        } catch (error) {
            console.error('Failed to copy text: ', error);
        }
    };

    return (
        <div>
            <Auth />
            <ToastContainer />
            <div className="app-header">
                <div className="tf-container">
                    <div className="tf-topbar d-flex justify-content-between align-items-center">
                        <Link className="user-info d-flex justify-content-between align-items-center" to="/profile">
                            <img src="assets/images/user/profile1.jpg" alt="User" />
                            <div className="content">
                                <h4 className="white_color">{localStorage.getItem('name')}</h4>
                                <p className="white_color fw_4">Let’s save your money!</p>
                            </div>
                        </Link>
                        <Link to="#" className="icon-notification1"><span>2</span></Link>
                    </div>
                </div>
            </div>

            <div className="card-secton">
                <div className="tf-container">
                    <div className="tf-balance-box">
                        <div className="balance">
                            <div className="row">
                                <div className="col-12 br-right">
                                    <div className="row mt-3 mb-3">
                                        <div className="col-10">
                                            <h4>{account ? `${account.slice(0, 10)}...${account.slice(-10)}` : "No Wallet Connected"}</h4>
                                        </div>
                                        <div className="col-2 text-end">
                                            <h4><i className="icon-copy1" onClick={copyToClipboard} /></h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-footer">
                            <div className="tf-container">
                                <ul className="box-service mt-3">
                                    <li><Link to="/Send"><div className="icon-box bg_color_1"><img src="assets/app/sendIcon.png" alt="Send" /></div>SENT</Link></li>
                                    <li><Link to="/qr-code"><div className="icon-box bg_color_2"><img src="assets/app/arrowDown.png" alt="Receive" /></div>RECEIVE</Link></li>
                                    <li><Link to="/swap"><div className="icon-box bg_color_3"><img src="assets/app/swapIcon.png" alt="Swap" /></div>SWAP</Link></li>
                                    <li><Link to="#"><div className="icon-box bg_color_4"><img src="assets/app/cartIcon.jpg" alt="Buy" /></div>BUY</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="app-section st1 mt-1 mb-5 bg_white_color">
                <div className="tf-container">
                    <div className="trading-month">
                        <div className="group-trading-history mb-5">
                            <TokenItem icon="bnbIcons.png" balance={bnbBalance} symbol="BNB" />
                            <TokenItem icon="usdtIcon.png" balance={usdtBalance} symbol="USDT" />
                            <TokenItem icon="rainoicon.webp" balance={rainoBalance} symbol="RAINO" />
                            <TokenItem icon="mbitIcon.png" balance={mbitBalance} symbol="MBIT" />
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer Navigation */}
            <div className="bottom-navigation-bar">
                <div className="tf-container">
                    <ul className="tf-navigation-bar">
                        <li className="active"><Link to="/"><i className="icon-home2" /> Home</Link></li>
                        <li><Link to="/history"><i className="icon-history" /> History</Link></li>
                        <li><Link to="/web3wallet"><i className="icon-scan-qr-code" /></Link></li>
                        <li><Link to="/rewards"><i className="icon-star" /> Rewards</Link></li>
                        <li><Link to="/profile"><i className="icon-user-outline" /> Profile</Link></li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

// Reusable component for tokens
function TokenItem({ icon, balance, symbol }) {
    return (
        <>
            <Link className="tf-trading-history" to="#">
                <div className="inner-left">
                    <div className="icon-box">
                        <img src={`/assets/images/coins/${icon}`} alt={symbol} />
                    </div>
                    <div className="content">
                        <h4>{balance} {symbol}</h4>
                        <p>$ Loading...</p>
                    </div>
                </div>
            </Link>
            <hr />
        </>
    );
}

export default Web3wallet;
